import { useQuery } from "@tanstack/react-query";

import { getMe } from "@/api/auth";
import { queryKeys } from "@/api/queryKeys";

export function useMe() {
  return useQuery({
    queryKey: queryKeys.auth.me(),
    queryFn: getMe,
    retry: false,
    staleTime: 60_000,
  });
}
